import React from 'react';
import Carousel, { CarouselItem } from '../../../../../components/Carousel/Carousel';
import img1 from '../../../../../assets/carousel1.png';
import img2 from '../../../../../assets/slide2.png';

function LoginCarousel() {
    return (
        <Carousel>
            <CarouselItem>
                <div className="mt-5 p-3 carouselInner">
                    <div className="p-5">
                        <p className="forCompaniesWith">CURATED, FAST, FLEXIBLE.</p>
                        <h4 className="mt-3 accessYourAn">
                            Get Debt for <br /> Your Business.
                        </h4>
                        <p className="mt-3 allowsYou">
                            Recur Club provides you with a <br />
                            capital term sheet in just 48 hours.
                        </p>
                    </div>
                </div>
            </CarouselItem>
            <CarouselItem>
                <div className="p-3 carouselInner">
                    <div className="p-4">
                        <img className="carouselLogo" src={img1} alt="logo" />
                        <div className="mt-3 recurSaves">
                            Recur Club saves 2 most valuable things <br /> founders,
                            <span style={{ color: '#57A4DD' }}> Time and Equity</span>.
                        </div>
                        <div className="mt-4">Manoj Agarwal</div>
                        <p className="allowsYou">Co-Founder & CEO, XoxoDay</p>
                    </div>
                </div>
            </CarouselItem>
            <CarouselItem>
                <div className="p-3 carouselInner">
                    <div className="p-4">
                        <img className="carouselLogo" src={img2} alt="logo" />
                        <div className="mt-3 recurSaves">
                            Time required to get funds is
                            <span style={{ color: '#57A4DD' }}> magically fast.</span>
                            <br />
                            Subscription based financing that doesn't dilute
                            <br /> equity is a<span style={{ color: '#57A4DD' }}> no brainer!</span>
                        </div>
                        <div className="mt-4">Vijay</div>
                        <p className="allowsYou">Co-Founder & CEO, KekaHR</p>
                    </div>
                </div>
            </CarouselItem>
        </Carousel>
    );
}

export default LoginCarousel;
